import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { ValidatorFn } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { emailValidator, noWhitespaceValidator } from '@recruitee/common';
import { InputComponent, SelectComponent } from '@recruitee/user-interface';

import type { DynamicCandidateEmailsInputConfig, SelectOptionsT } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';

export class CandidateEmailInput extends DynamicFormInput<DynamicCandidateEmailsInputConfig> {
  public isHidden(): boolean {
    return !this.config.required && !!this.config.hideIfEmpty && !this.config.emails.length;
  }
  protected validators(): ValidatorFn[] {
    return super.validators().concat([noWhitespaceValidator, emailValidator]);
  }
}

@Component({
  selector: 'rti-candidate-email-input',
  templateUrl: './candidate-email-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, InputComponent, SelectComponent],
})
export class CandidateEmailInputComponent {
  @Input() public input: CandidateEmailInput;

  public hasEmail: boolean = false;
  public emailOptions: SelectOptionsT;

  public ngOnChanges(changes: SimpleChanges): void {
    if ('input' in changes) {
      this.hasEmail = changes.input.currentValue.config.emails.length > 0;
      this.emailOptions = this.toOptions(changes.input.currentValue.config.emails);
    }
  }

  public get includeEmptyOption(): boolean {
    return !this.input.config.required;
  }

  private toOptions(values: string[]): SelectOptionsT {
    return values.map(v => ({ label: v, value: v }));
  }
}
